import React__default from 'react';
import { ServiceIconConfig } from '../ServiceIcon/constants.es.js';

const serviceIcon = "_service-icon_1qej2_1";
const styles = {
	serviceIcon: serviceIcon
};

const ServiceIconShell = ({ children, hasBorder = true, hasShadow = false, hasWhiteBackground = false, size }) => {
  return React__default.createElement("span", { className: styles.serviceIcon, "data-border": hasBorder, "data-shadow": hasShadow, "data-background": hasWhiteBackground ? "white" : "default", "data-size": size, "data-zds": true, "data-testid": "ServiceIconShell", style: {
    "--width": ServiceIconConfig[size].width,
    "--height": ServiceIconConfig[size].width,
    "--border-radius": ServiceIconConfig[size].borderRadius
  } }, children);
};

export { ServiceIconShell };
//# sourceMappingURL=ServiceIconShell.es.js.map
